module.exports = __webpack_public_path__ + "static/12-lathe-zoom-ea284c869d75b9c2c6200bb0eac24141.jpg";